import { Component, Inject, OnInit, ViewChild, AfterViewInit, ElementRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ApiService } from '@quorum/api';
import { HttpClient } from '@angular/common/http';
@Component({
  selector: 'svc-scanner-dialog',
  templateUrl: './scanner-dialog.component.html',
  styleUrls: ['./scanner-dialog.component.scss'],
})
export class ScannerDialogComponent implements OnInit, AfterViewInit {
  vinScan: boolean = false;
  licenseScan: boolean = false;
  configQuagga = {
    inputStream: {
      name: 'Live',
      type: 'LiveStream',
      target: '#inputBarcode',
      constraints: {
        width: { min: 640 },
        height: { min: 480 },
        aspectRatio: { min: 1, max: 100 },
        facingMode: 'environment', // or user
      },
      singleChannel: false, // true: only the red color-channel is read
    },
    locator: {
      patchSize: 'medium',
      halfSample: true,
    },
    locate: true,
    numOfWorkers: 4,
    decoder: {
      readers: ['code_128_reader'],
    },
  };
  cameraView: any;
  cameraOutput: any;
  cameraSensor: any;
  cameraTrigger: any;
  @ViewChild('videoPlayer') videoplayer: ElementRef;
  constructor(
    public dialogRef: MatDialogRef<ScannerDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: any,
    private apiService: ApiService,
    private httpClient: HttpClient
  ) {}

  barcodeValue: string;

  ngAfterViewInit() {}

  onValueChanges(result: any) {
    this.barcodeValue = result.codeResult.code;
  }

  startVinScanner() {
    this.vinScan = true;

    //this.barecodeScanner.start();
  }

  startLicensePlateScanner() {
    this.licenseScan = true;

    this.cameraView = document.querySelector('#camera--view');
    this.cameraOutput = document.querySelector('#camera--output');
    this.cameraSensor = document.querySelector('#camera--sensor');
    this.cameraTrigger = document.querySelector('#camera--trigger');

    const constraints = { video: { facingMode: 'environment' }, audio: false };
    let self = this;
    navigator.mediaDevices.getUserMedia(constraints).then((stream) => {
      let track = stream.getTracks()[0];
      console.log(this.videoplayer.nativeElement);
      const video: HTMLVideoElement = this.videoplayer.nativeElement;
      video.srcObject = stream;
      //self.videoPlayer.nativeElement.srcObject = stream;
      //self.cameraView.srcObject = stream;
    });
  }

  captureImage() {
    // this.snapshot.width = this.player.videoWidth;
    // this.snapshot.height = this.player.videoHeight;
    // this.snapshot.getContext('2d').drawImage(this.player, 0, 0);
    let imgUrl: string = this.cameraSensor.toDataURL();

    this.httpClient
      .post(`https://n86904ob12.execute-api.us-east-1.amazonaws.com/dev/image-test`, {
        image: imgUrl.replace('data:image/png;base64,', ''),
      })
      .subscribe((result: any) => {
        console.log(result);
        console.log(result.input.split('\n'));
        alert(result.input.split('\n').join(','));
      });
    //cameraOutput.classList.add("taken");
  }
  ngOnInit() {}

  onSubmit() {
    this.dialogRef.close({});
  }

  changeFiles(e: any) {
    let file = e.target.files[0];
    var FR = new FileReader();
    let self = this;
    FR.addEventListener('load', function (e: any) {
      self.httpClient
        .post(`https://n86904ob12.execute-api.us-east-1.amazonaws.com/dev/image-test`, {
          image: e.target.result.replace('data:image/png;base64,', ''),
        })
        .subscribe((result: any) => {
          console.log(result);
          console.log(result.input.split('\n'));
        });
    });

    FR.readAsDataURL(file);
  }
}
